
import React from 'react';
import { useSound } from '../contexts/SoundContext';

const SoundToggle: React.FC = () => {
  const { isSoundEnabled, toggleSound } = useSound();

  return (
    <button 
      onClick={toggleSound} 
      className="p-2.5 rounded-full text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
      aria-label={isSoundEnabled ? 'Mute sound' : 'Unmute sound'}
    >
      {isSoundEnabled ? (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.59-.79-1.59-1.59V9.84c0-.88.79-1.59 1.59-1.59h2.24z" />
        </svg>
      ) : (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.25 9.75L19.5 12m0 0l2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-12 5.25H4.51c-.88 0-1.59-.79-1.59-1.59V9.84c0-.88.79-1.59 1.59-1.59h2.24l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72z" />
        </svg>
      )}
    </button>
  );
};

export default SoundToggle;
